<!--- //
服务器配置管理
@auth xuyd
// -->
<template>
  <page-layout layout="C">
    <FtpList />
    <SshList />
  </page-layout>
</template>
<script>
import FtpList from "./ftp-list";
import SshList from "./ssh-list";

export default {
  name: 'ViewRemoteList',
  components: {FtpList, SshList}
}
</script>
